import { BiChair, BiTennisBall } from "react-icons/bi";
import { CgGym, CgSmartHomeCooker } from "react-icons/cg";
import { FaCouch, FaSnowflake, FaTv, FaWater } from "react-icons/fa";
import {
  GiBarbecue,
  GiField,
  GiFlowers,
  GiKnifeFork,
  GiLift,
  GiPartyFlags,
  GiSoccerField,
  GiWaterDrop,
} from "react-icons/gi";
import { HiSun } from "react-icons/hi";
import {
  MdGames,
  MdHotTub,
  MdKitchen,
  MdMovie,
  MdPets,
  MdPool,
  MdSecurity,
  MdToys,
} from "react-icons/md";

export const CHARACTERISTICS = [
  { Icon: MdPets, title: "Pet Friendly" },
  { Icon: GiWaterDrop, title: "Água Inclusa" },
  { Icon: CgSmartHomeCooker, title: "Gás Incluso" },
  { Icon: FaCouch, title: "Mobiliado" },
  { Icon: FaSnowflake, title: "Ar-condicionado" },
  { Icon: GiField, title: "Quintal" },
  { Icon: HiSun, title: "Sacada" },
  { Icon: MdKitchen, title: "Despensa" },
  { Icon: FaTv, title: "TV à Cabo" },
  { Icon: GiBarbecue, title: "Churrasqueira" },
  { Icon: GiLift, title: "Elevador" },
  { Icon: GiFlowers, title: "Jardim" },
  { Icon: GiKnifeFork, title: "Espaço Gourmet" },
  { Icon: CgGym, title: "Academia" },
  { Icon: GiPartyFlags, title: "Salão de Festas" },
  { Icon: MdToys, title: "Playground" },
  { Icon: MdPool, title: "Piscina" },
  { Icon: MdMovie, title: "Sala de Cinema" },
  { Icon: BiTennisBall, title: "Quadra de Tênis" },
  { Icon: GiSoccerField, title: "Área para Esportes" },
  { Icon: MdHotTub, title: "Sauna" },
  { Icon: MdHotTub, title: "SPA" },
  { Icon: FaWater, title: "Vista para o Mar" },
  { Icon: BiChair, title: "Varanda Gourmet" },
  { Icon: MdSecurity, title: "Portaria 24h" },
  { Icon: MdGames, title: "Salão de Jogos" },
];
